// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image {\n    position:relative;\n    z-index:0;\n}\n\n.nomove {\n    position:absolute;\n    top:0px;\n    left:0px;\n    width:100%;\n    height:100%;\n    background:/*rgba(0,0,0,0.5);*/ transparent;\n    z-index:2;\n}\n\n.row-of-icons {\n    -webkit-user-select: none;  /* Chrome all / Safari all */\n    -moz-user-select: none;     /* Firefox all */\n    -ms-user-select: none;      /* IE 10+ */\n    user-select: none;          /* Likely future */\n}", ""]);
// Exports
module.exports = exports;
